import React, { createElement, JSX, ReactNode } from "react";
import { style } from "../style";

export default function TitleSquare(props: { tall?: boolean })
{
    let square: ReactNode = <div className={style.titleSquare} />
    if (props.tall)
    {
        square = <div className={style.titleSquare + " !h-12"} />;
    }
    return (
        square
    )
}
